import script from "./readytips.vue?vue&type=script&setup=true&lang=js"
export * from "./readytips.vue?vue&type=script&setup=true&lang=js"

import "./readytips.vue?vue&type=style&index=0&id=aa0ebbbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa0ebbbc"]])

export default __exports__